import { reactive } from 'vue'
import { possibleBackgrounds } from '@/stores/ui/store'
import {
  getBooleanStorageComputed,
  getEnumStorageComputed,
  getStringStorageComputed,
} from './computed'

export const storage = reactive({
  isUcaMode: getBooleanStorageComputed('isUcaMode', true),
  hasSeenConnectMeReleasePopup: getBooleanStorageComputed(
    'hasSeenConnectMeReleasePopup',
    false
  ),
  areHelpTipsVisible: getBooleanStorageComputed('areHelpTipsVisible', true),
  isHelpTipsPopupVisible: getBooleanStorageComputed(
    'isHelpTipsPopupVisible',
    true
  ),
  easybellDeAuth: getStringStorageComputed('authToken'),
  authMode: getEnumStorageComputed(
    'authMode',
    ['api', 'keycloak', 'easybell-jwt'],
    undefined
  ),
  shouldSkipStartModal: getBooleanStorageComputed(
    'should-skip-entra-import-start-modal',
    false
  ),
  background: getEnumStorageComputed(
    'test-background',
    possibleBackgrounds,
    'test-environment'
  ),
  whoami: getStringStorageComputed('whoami'),
})
